import React from "react"
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks"
import { editAttributes } from "../../../../../services/verifyService/model/verification/VerificationSlice";
import { ReduxUpdate } from "../../../../../utils/ReduxUpdateCommands";
import { Switch } from "@progress/kendo-react-inputs";
import { toggleEscalatedNoteAddModal } from "../../../../../app/slices/VerificationModuleSlice";
import { EscalatedNoteAdd } from "../notes/EscalatedNoteAdd";

function IsEscalatedAttribute(){
    const dispatch = useAppDispatch();
    const verify = useAppSelector((state)=>state.verification.verification);
    
    const handleEscalatedChange = (e: any) => {
        const newValue = e.target.value;
        dispatch(editAttributes(new ReduxUpdate("isEscalated", newValue)));
        
        // Open the escalated note modal when switch is turned ON
        if (newValue) {
            dispatch(toggleEscalatedNoteAddModal());
        }
    }
    
    return <React.Fragment>
        <div>
            <label>Facility Request</label><br/>
            <Switch name='isEscalated' value={verify.verifyAttributes.isEscalated??false} 
                checked={verify.verifyAttributes.isEscalated} 
                onChange={handleEscalatedChange}/>
        </div>
        <EscalatedNoteAdd/>
    </React.Fragment>
}
export {IsEscalatedAttribute}
